<template>
  <div class="row">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Service</th>
            <th>Sub Service</th>
            <th>Work</th>
            <th>Resources</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="permissions?.length">
          <tr v-for="permission in permissions" :key="`permission_policy_${permission.id}`">
            <td>{{ permission?.cloud_service?.name }}</td>
            <td>{{ permission?.cloud_sub_service?.name }}</td>
            <td>{{ permission?.cloud_work?.name }}</td>
            <td>
              <template v-if="permission?.server_resource">
              {{ permission?.server_resource?.server_name }}
              </template>
              <template v-if="permission?.disk_resource">
              {{ permission?.disk_resource?.name }}
              </template>
              <template v-if="permission?.network_resource">
              {{ permission?.network_resource?.public_ip }}
              </template>
              <template v-if="permission?.ssh_resource">
                {{ permission?.ssh_resource?.name }}
              </template>
            </td>
          </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="my-3">
        <div class="text-center">
          <button
              type="button"
              class="btn btn-secondary btn-md width_100p"
              @click="closeModal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PolicyPermissionView',
  props: ['closeModal', 'permissions'],
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>
<style scoped>
</style>
  